module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-wrap bg--about"
  }, [_c('div', {
    staticClass: "about-container clear"
  }, [_c('h2', {
    staticClass: "center caps"
  }, [_vm._v("About")]), _vm._v(" "), _c('h1', {
    staticClass: "spacer--small"
  }, [_vm._v("A guide to typography with character.")]), _vm._v(" "), _c('h3', {
    staticClass: "serif weight--400"
  }, [_vm._v("Hi there!")]), _vm._v(" "), _c('h3', {
    staticClass: "serif weight--400"
  }, [_vm._v("It all began when I realized I could combine my love for cultural comparisons and graphic design. This has taken many forms during my studies and has stayed with me since.")]), _vm._v(" "), _c('h3', {
    staticClass: "serif weight--400"
  }, [_vm._v("By comparing English and Korean, Types of Type shows that there are many similarities across the two languages through the lens of typography. And, the differences between the two are equally telling. I learned a lot from putting this guide together, and hope you enjoy it.")]), _vm._v(" "), _c('h3', {
    staticClass: "serif weight--400"
  }, [_vm._v("Amanda")]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small"
  }), _vm._v(" "), _c('div', {
    staticClass: "column--half spacer--small"
  }, [_c('p', [_c('span', {
    staticClass: "bold"
  }, [_vm._v("\n                  Writing and Design\n              ")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "serif"
  }, [_c('div', {
    staticClass: "headshot"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/about/amanda-lui.png",
      "alt": "Amanda"
    }
  }), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "about-link"
  }, [_c('a', {
    attrs: {
      "href": "http://amandalui.com",
      "target": "_blank"
    }
  }, [_vm._v("Amanda Lui")])]), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Designer")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "social-media"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/amandalui",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/about/icon-git.svg",
      "alt": "Github"
    }
  })])]), _c('br')])]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "bold"
  }, [_vm._v("\n                    Website in collaboration with\n              ")]), _c('br')]), _c('div', {
    staticClass: "serif column--half"
  }, [_c('div', {
    staticClass: "headshot"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/about/jeremiah-montoya.png",
      "alt": "Jeremiah"
    }
  }), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "about-link"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/thisjeremiah",
      "target": "_blank"
    }
  }, [_vm._v("Jeremiah Montoya")])]), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Developer")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "social-media"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/thisjeremiah",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/about/icon-git.svg",
      "alt": "Github"
    }
  })])]), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "serif column--half"
  }, [_c('div', {
    staticClass: "headshot"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/about/nathan-specht.png",
      "alt": "Nathan"
    }
  }), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "about-link"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/nathanspecht",
      "target": "_blank"
    }
  }, [_vm._v("Nathan Specht")])]), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Developer")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "social-media"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/nathanspecht",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/about/icon-git.svg",
      "alt": "Github"
    }
  })])]), _c('br')]), _vm._v(" "), _c('p'), _vm._v(" "), _c('div', {
    staticClass: "clear spacer--tiny"
  }), _vm._v(" "), _c('p', {
    staticClass: "about-link"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Special Thanks")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "serif"
  }, [_c('a', {
    attrs: {
      "href": "http://romanjaster.com/",
      "target": "_blank"
    }
  }, [_vm._v("Roman Jaster")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "serif"
  }, [_c('a', {
    attrs: {
      "href": "http://soonsol.com/",
      "target": "_blank"
    }
  }, [_vm._v("Soonsol Hong")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "serif"
  }, [_c('a', {
    attrs: {
      "href": "https://elizabethjayna.com/",
      "target": "_blank"
    }
  }, [_vm._v("Elizabeth Lui")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "serif"
  }, [_c('a', {
    attrs: {
      "href": "http://cargocollective.com/herimshin",
      "target": "_blank"
    }
  }, [_vm._v("Herim Shin")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "serif"
  }, [_vm._v("Andrea Juhie Kim")])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "about-link"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Colophon")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "serif"
  }, [_vm._v("English type set in "), _c('a', {
    attrs: {
      "href": "https://fonts.google.com/specimen/Work+Sans",
      "target": "_blank"
    }
  }, [_vm._v("Work Sans")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "https://fonts.google.com/specimen/Bitter",
      "target": "_blank"
    }
  }, [_vm._v("Bitter")]), _vm._v(". Korean type set in "), _c('a', {
    attrs: {
      "href": "https://www.google.com/get/noto/help/cjk/",
      "target": "_blank"
    }
  }, [_vm._v("Noto Sans CJK")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "http://hangeul.naver.com/",
      "target": "_blank"
    }
  }, [_vm._v("Nanum Myeongjo")]), _vm._v(". Made with "), _c('a', {
    attrs: {
      "href": "https://vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("Vue")]), _vm._v(".")])])]), _vm._v(" "), _c('div', {
    staticClass: "column--one-third spacer--small spacer--left caption about-link"
  }, [_c('p', [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', [_vm._v("Boardly, John. “The Origins of Abc” I Love Typography. 07 Aug 2010. "), _c('a', {
    attrs: {
      "href": "http://ilovetypography.com/",
      "target": "_blank"
    }
  }, [_vm._v("ilovetypeography.com")])]), _vm._v(" "), _c('p', [_vm._v("Bringhurst, Robert. The Elements of Typographic Style. Point Roberts, WA: Hartley & Marks, 2002.")]), _vm._v(" "), _c('p', [_vm._v("Graig, James and Susan E. Meyer Designing with Type: A Basic Course in Typography. New York: Watson-Guptill Publications, 1980.")]), _vm._v(" "), _c('p', [_vm._v("Glyph of the Day. "), _c('a', {
    attrs: {
      "href": "http://www.glyphs.webfoot.com",
      "target": "_blank"
    }
  }, [_vm._v("glyphs.webfoot.com")])]), _vm._v(" "), _c('p', [_vm._v("Kim, Young-hyun, and Sang-yeon Park. Tree With Deep Roots. SBS. Seoul, 2011. Television.")]), _vm._v(" "), _c('p', [_vm._v("Korean Typographics Association. KaNaDaRa. 4th ed. Vol 1. Seoul: Korean Typographics Association, 2012.")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    staticClass: "spacer--medium clear"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ec64d26","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/About.vue
// module id = 141
// module chunks = 0